import { render } from "./Lists.vue?vue&type=template&id=2af526de&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=ts"
export * from "./Lists.vue?vue&type=script&lang=ts"

import "./Lists.vue?vue&type=style&index=0&id=2af526de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2af526de"

export default script